<template>
    <span :title="$t('Copy')" class="text-copy" v-clipboard="text || hiddenText" v-clipboard:success="clipboardSuccessHandler" v-clipboard:error="clipboardErrorHandler" >
      <span v-if="!hiddenIcon"><i class="fas fa-copy text-copy-icon"></i>&nbsp;</span><span v-if="hiddenText">{{ $t('Copy') }}</span><span v-else>{{ text }}</span>
    </span>
</template>

<script>
    export default {
        name: 'clipboard',
        props: ['text', 'hiddenText', 'hiddenIcon'],
        methods: {
            clipboardSuccessHandler ({ value, event }) {
                value && $.toast({
                    heading: this.$t('Success'),
                    text: this.$t('The data has been copied!'),
                    showHideTransition: 'slide',
                    icon: 'success',
                    loaderBg: '#ddd',
                    position: 'top-center'
                })
            },

            clipboardErrorHandler ({ value, event }) {
                console.log('error', value)
            }
        }
    }
</script>

<style scoped>
    .el-icon-document-copy {
        color: #0d5aff;
    }
    .text-copy {
        cursor: pointer;
        text-decoration-style: dotted;
        border-bottom: 1px dotted;
        margin-left: 0px !important;
    }
    .text-copy-icon {
        color: #b7b7b7;
    }
</style>